<template>
  <div class="supervise">
    <ol>
      <li>
        <router-link to="/TeamList" replace>
          <div>
            <span>服务团队</span>
          </div>
        </router-link>
      </li>
      <!--<li>
        <router-link to="/Service" replace>
          <div>
            <span>维护公开</span>
          </div>
        </router-link>
      </li>-->
      <li>
        <router-link to="/Check" replace>
          <div>
            <span>评估查验</span>
          </div>
        </router-link>
      </li>
    </ol>
    <!--显示子路由内容部分-->
    <router-view></router-view>
  </div>
</template>
<style lang="scss">
  .supervise {
    width: 100%;
    padding-top: 40px;
    ol {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #d7d7d7;
      list-style: none;
      background: #fff;
      right: 0;
      left: 0;
      position: fixed;
      z-index: 666;
      li {
        /*width: 32.2%;*/
        width: 48.5%;
        float: left;
        height: 50px;
        text-align: center;
        margin-left: 2px;
        border-right: 1px solid #d7d7d7;
        a {
          width: 100%;
          color: #000000;
          font-size: 15px;
          font-weight: bolder;
          text-align: center;
          text-decoration: none;
          div {
            height: 48px;
            span {
              line-height: 50px;
            }
          }
        }
        a.active {
          color: #0078de;
          font-size: 15px;
          font-weight: bolder;
          text-align: center;
          div {
            border-bottom: 3px solid #0078de;
          }
        }
      }
      li:first-child {
        border-left: none;
      }
      li:last-child {
        border-right: none;
      }
    }
  }
</style>
<script>
  export default {
    name: 'Supervise',
    data() {
      return {}
    },
    created() {
    },
    components: {},
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/content/Supervise.vue